import { createSelector, selector } from '@/store/utils';

const selectProfileData = selector((state) => state.profile.current);
export const profileDataSelector = createSelector(selectProfileData);

const selectActiveTicketsProfile = selector(
  (state) => state.profile.bookings?.tickets.active
);
export const activeTicketsProfileSelector = createSelector(
  selectActiveTicketsProfile
);

const selectHistoryTicketsProfile = selector(
  (state) => state.profile.bookings?.tickets.history
);
export const historyTicketsProfileSelector = createSelector(
  selectHistoryTicketsProfile
);

const selectUpcomingTravelPassesProfile = selector(
  (state) => state.profile.bookings?.travelPasses.active
);
export const activeTravelPassesProfileSelector = createSelector(
  selectUpcomingTravelPassesProfile
);

const selectHistoryTravelPassesProfile = selector(
  (state) => state.profile.bookings?.travelPasses.history
);
export const historyTravelPassesProfileSelector = createSelector(
  selectHistoryTravelPassesProfile
);
